@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;
}

.vm-video-related-content {
    display: flex;
    gap: 12px;
    flex-direction: column;

    &__title {
        margin: 0;
        font-size: mixins.get-font-size(text-lg);
        line-height: mixins.get-line-height(text-lg);
        color: mixins.get-color(text, text-primary);
        font-weight: 400;

        @include mixins.desktop-and-up {
            font-size: mixins.get-font-size(text-md);
            line-height: mixins.get-line-height(text-md);
        }
    }

    &__list {
        display: flex;
        flex-direction: column;
        gap: 16px;

        ::slotted(vm-video-card-related:not(:first-child)) {
            padding-top: 16px;
            border-top: solid 1px;
            border-color: mixins.get-color(border, border-secondary);
        }

        @include mixins.desktop-and-up {
            ::slotted(vm-video-card-related:not(:first-child)) {
                padding-top: unset;
                border-top: unset;
            }
        }
    }

    &__cta {
        width: 100%;
        &::part(button) {
            @include mixins.desktop-and-up {
                border: none;
            }
        }
    }
}
